import { render, staticRenderFns } from "./TeacherProfilePage.vue?vue&type=template&id=1f5b3632&scoped=true"
import script from "./TeacherProfilePage.vue?vue&type=script&lang=js"
export * from "./TeacherProfilePage.vue?vue&type=script&lang=js"
import style0 from "./TeacherProfilePage.vue?vue&type=style&index=0&id=1f5b3632&prod&lang=stylus&scoped=true"
import style1 from "./TeacherProfilePage.vue?vue&type=style&index=1&id=1f5b3632&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5b3632",
  null
  
)

export default component.exports